import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_COMPANIES, API_GET_COMPANY} from "../actions/companies";
import moment from "moment";

/*
Structure of companies model

{
  data: {
    [companyid]: {
      resource: {
        id: string // uuid
        companyname: string
        address: string
        address2: string
        city: string
        state: string
        zip: string
        active: bool
        companytype: string
        website: string
        email: string
        phone: string
        fax: string
        industries: array of string // code-driven code_industry
        sectors: array of string // code-driven code_sector
        csicodes: array of string // code-driven code_csi
        subcompanytype: string
        abbreviation: string
        logo: string // path
        customreportskey:
        hastmpemailaddresslists:
        isprojectmoduleon: bool
        isbidmoduleon: bool
        hasbidsettings: bool
        bidsettingdisablebidthirdpartycontacts: bool
        datecreated: datetime
        pqf: json
      }
      cache: {
        loading: boolean
        fetched: datetime
        error: string
      }
    }
  }
  indexes: {}
}
 */

const companiesInitial = {
  data: {},
  indexes: {},
};

const companiesReducer = createReducer(companiesInitial,
  {
    [ADD_COMPANIES]: (state, action) => {
      let newState = state;
      const { payload: companies } = action;
      companies.forEach(company => {
        let newData = {
          resource: company,
          cache: {
            loading: false,
            fetched: moment(),
            error: null,
          }
        };
        newState = R.set(R.lensPath(['data', company.id]), newData, newState);
        newState = R.set(R.lensPath(['indexes', (company.companyname || '').replace(/[^\w]+/g, '').toLocaleLowerCase()]), company.id, newState);
      });
      return newState;
    },
    [API_GET_COMPANY]: (state, action) => {
      const { payload: { id }} = action;
      return R.pipe(
        R.set(R.lensPath(['data', id, 'cache', 'loading']), true),
        R.set(R.lensPath(['data', id, 'resource', 'id']), id)
      )(state);
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default companiesReducer;



// WEBPACK FOOTER //
// ./src/reducers/companies.js